import React from 'react'
import {
  useTranslate,
  useRecordContext,
} from 'react-admin'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'
import { Box, Typography } from '@mui/material'
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople'
import { turquoise } from 'src/assets/colors'

export const TrainPassesExtraPassenger = ({ data }) => {
  const record = useRecordContext()
  const train_passes = data ? data : record?.passes?.[0]
  const translate = useTranslate()

  if (
    train_passes &&
    train_passes?.extra &&
    Array.isArray(train_passes?.extra) &&
    train_passes?.extra.length > 0
  ) {
    return (
      <Box style={{ border: '4px solid #F9F9FD', borderRadius: '10px', padding: 10 }}>
        <Typography variant='h6' component='div'>
          Pasajeros
        </Typography>
        {train_passes.extra.map((extra_pass, key) => {
          return (
            <Box
              display={'flex'}
              style={{ border: '4px solid #F9F9FD', borderRadius: '10px' }}
              marginY={1}
              key={key}
            >
              <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
                <EmojiPeopleIcon />
              </Box>
              <Box>
                <ShowElement
                  data={extra_pass?.name}
                  label={translate('ra.field.name')}
                  style={{ padding: 0 }}
                />
                <ShowElement
                  data={extra_pass?.ticketNumber}
                  label={translate('ra.field.ticketNumber')}
                  style={{ padding: 0 }}
                  styleValue={{ color: turquoise, fontWeight: 600 }}
                />
              </Box>
            </Box>
          )
        })}
      </Box>
    )
  }
}
